export const createThreadLoadCoordinator = () => {
  let generation = 0;

  return {
    begin: () => ++generation,
    isCurrent: (candidate: number) => candidate === generation,
    invalidate: () => {
      generation += 1;
    },
  };
};
